import React, { useContext } from 'react';
import moment from 'moment';
import { FiCalendar, FiMapPin } from 'react-icons/fi';

import { purple } from '@material-ui/core/colors';
import { RSVPContext } from '../../context';
import StickyFooter from '../../../../components/StickyFooter';
import { FlexFlow } from '../../../../components/styles/Layout';

import {
  LPTitle,
  LPText,
  ContentWrapper,
  HighlightItem,
  HighlightItemContent,
  HighlightItemTitle,
  HighlightItemText,
} from '../../../styles';

const StepLanding = () => {
  const {
    contextData: {
      eventItemData,
      goToNextStep,
    },
  } = useContext(RSVPContext);

  const {
    getVpn: {
      availableEvents,
    },
  } = eventItemData;

  const event = availableEvents[0];

  const {
    title,
    description,
    representationalMetadataList,
    date: {
      // timeZone,
      startDate,
      endDate,
      startTime,
      endTime,
    },
    location: {
      type: locationType,
      virtualLocation,
      venue,
    },
  } = event;

  const startDateStr = moment(startDate).format('ddd, MMM Do');
  const startDateTime = moment([startDate, startTime].join(' '));
  const endDateTime = moment([endDate, endTime].join(' '));

  const displayDate = [
    startDateStr,
    startDateTime.format('hh:mm A'),
    endDateTime.format('hh:mm A'),
  ].join(' - ');

  let locationName = '';
  let locationAddress = '';

  if (locationType === 'IN_PERSON') {
    const fullAddress = [
      venue.address,
      venue.city,
      venue.state,
      venue.zipCode,
    ].join(', ');
    locationName = venue.name;
    locationAddress = fullAddress;
  }

  if (locationType === 'VIRTUAL') {
    locationName = 'Online';
    locationAddress = virtualLocation;
  }

  const pageData = {
    instructions: '',
    btnLabel: '',
  };

  representationalMetadataList.forEach(({
    destination,
    content,
    type,
  }) => {
    if (destination === 'landing_page') {
      switch (type) {
        case 'BTN_LABEL':
          pageData.btnLabel = content;
          break;
        case 'INSTRUCTIONS':
          pageData.instructions = content;
          break;
        default:
          break;
      }
    }
  });

  return (
    <>
      <ContentWrapper>
        <LPText mb2>
          {pageData.instructions}
        </LPText>

        <LPTitle>
          {title}
        </LPTitle>

        <LPText w600>
          About
        </LPText>

        <LPText mb2>
          {description}
        </LPText>

        <FlexFlow column>
          <HighlightItem>
            <FiCalendar className="icon_start" />
            <HighlightItemContent>
              <HighlightItemTitle>
                {displayDate}
              </HighlightItemTitle>
              <HighlightItemText />
            </HighlightItemContent>
          </HighlightItem>

          <HighlightItem>
            <FiMapPin className="icon_start" />
            <HighlightItemContent>
              <HighlightItemTitle>
                {locationName}
              </HighlightItemTitle>
              <HighlightItemText>
                {locationAddress}
              </HighlightItemText>
            </HighlightItemContent>
          </HighlightItem>
        </FlexFlow>
      </ContentWrapper>

      <StickyFooter
        title={pageData.btnLabel}
        bgColor={purple[600]}
        handleOnclick={goToNextStep}
      />
    </>
  );
};

export default StepLanding;
